import { Form } from 'antd';
import React, { createContext } from 'react';

import { TableRow } from './styles';

export const EditableContext = createContext(null);

export const EditableRow = ({ ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <TableRow {...props} />
      </EditableContext.Provider>
    </Form>
  );
};
